export const WEB_MERCHANDISING_CARD_TILE_VARIATION = {
  SQUAREV1: 'square-v1',
  SQUAREV2: 'square-v2',
  SQUAREV3: 'square-v3',
  WIDE: 'tile-wide',
};
export const PRIMARY_MEDIA = 'primary';
export const SECONDARY_MEDIA = 'secondary';
export const SQUARE_IMG = 'Square';
export const WIDE_HOR_IMG = 'Wide-Hor';
export const CLASSIC_VERTICAL = 'Classic-Ver';
export const TERTIARY_MEDIA = 'tertiary';
export const COMPONENT_POSITION = {
  CENTER: 'center',
  TOP: 'top',
  BOTTOM: 'bottom',
};
export const ASSET_VARIATION = {
  IMAGE: 'image',
};
export const ASPECT_RATIO_UXL_FIELD_MAPPING = {
  'Wide-Hor': 'wideHorizontal',
  'Pano-Hor': 'panoramicHorizontal',
  'Pano-Ver': 'panoramicVertical',
  'Wide-Ver': 'wideVertical',
  'Feature-Hor': 'featureHorizontal',
  'Feature-Ver': 'featureVertical',
  'Classic-Hor': 'classicHorizontal',
  'Classic-Ver': 'classicVertical',
  Square: 'square',
};
export const APP_TILE_SQUARE_VARATIONS = {
  squarev1: 'square-v1',
  squarev2: 'square-v2',
  squarev3: 'square-v3',
  tall: 'tall',
  wide: 'wide',
};
export const IMAGE_CACHE_DOMAIN = 'https://cache.marriott.com';
